export default "__VITE_ASSET__BTBsnP9H__"